import stringHelpers from "../../utilities/stringHelpers";
import { AppliedFilterDisplay } from "./appliedFilterDisplay";
import { AppliedMultiFilterDisplay } from "./appliedMultiFilterDisplay";

export const TagFilterItemLabel = ({ tag }) => (
    <div className="d-flex align-items-center">
        <i className="fas fa-circle mr-2 ml-1 mb-0 fs--1" style={ { color: `#${ tag.colourCode }` } }></i>
        <p className="m-0">{ tag.name }</p>
    </div>
)

export const renderTagFilterItemLabel = (label, item) => <TagFilterItemLabel tag={ item } />

const renderPlainItemLabel = (label, item) => <p className="m-0">{ item.name }</p>

export const AppliedFilterPill = ({ label, value, onCloseClick, onRemoveItem, onTextClick, isResettable = false, isLabelOnly = false, renderItemLabel = renderPlainItemLabel }) => {
    if (Array.isArray(value)) {
        const multiFilterItems = value.map(item => ({ id: item.id, label: renderItemLabel(label, item) }))
        return (
            <div className="mr-2">
                <AppliedMultiFilterDisplay
                    parentKey={ label }
                    filters={ multiFilterItems }
                    onCloseClick={ onCloseClick }
                    onRemoveItem={ removedItemId => onRemoveItem(label, value.filter(item => item.id !== removedItemId).map(item => item.id)) }
                    onTextClick={ onTextClick }
                />
            </div>
        )
    }

    if (stringHelpers.isNullOrEmpty(value)) {
        return null
    }

    return (
        <div className="mr-2">
            <AppliedFilterDisplay
                label={ label }
                value={ value }
                isResettable={ isResettable }
                isLabelOnly={ isLabelOnly }
                onCloseClick={ onCloseClick }
                onTextClick={ onTextClick }
            />
        </div>
    )
}
